const localizeForm = (
  formObject,
  {
    ORGANIZATION_FORM_ORGANIZATIONKEY_LABEL,
    ORGANIZATION_FORM_ORGANIZATIONKEY_PLACEHOLDER,
    ORGANIZATION_FORM_ORGANIZATIONKEY_ERROR,
    ORGANIZATION_FORM_ISPHONICSENABLED_LABEL,
  }
) => {
  const updatedForm = {
    ...formObject,
    formField: {
      ...formObject.formField,
      organizationKey: {
        ...formObject.formField.organizationKey,
        label:
          ORGANIZATION_FORM_ORGANIZATIONKEY_LABEL ?? formObject.formField.organizationKey.label,
        placeholder:
          ORGANIZATION_FORM_ORGANIZATIONKEY_PLACEHOLDER ??
          formObject.formField.organizationKey.placeholder,
        errorMsg:
          ORGANIZATION_FORM_ORGANIZATIONKEY_ERROR ?? formObject.formField.organizationKey.errorMsg,
      },
      isPhonicsEnabled: {
        ...formObject.formField.isPhonicsEnabled,
        label:
          ORGANIZATION_FORM_ISPHONICSENABLED_LABEL ?? formObject.formField.isPhonicsEnabled.label,
      },
    },
  };
  return updatedForm;
};

export default localizeForm;
